
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms",
      function () {
        return require("private-next-pages/terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms"])
      });
    }
  